module.exports = __webpack_public_path__ + "static/resume-c4b67d358d9db748d9ac2a94e7e958f9.pdf";